import { UserFlag } from "@/services/user/settings/flags";

/** @throws {Error} When user flags are not unique */
export const assertUserFlagsAreUnique = (userFlags: UserFlag[]): void => {
  if (new Set(userFlags).size !== userFlags.length) {
    throw new Error("User flags must be unique.");
  }
};
